import { PRODUCTS_URL, UPLOAD_URL } from '../constants';
import { apiSlice } from './apiSlice';

export const productsApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getProducts: builder.query({
			query: () => ({
				url: PRODUCTS_URL,
			}),
			providesTags: ['Product'],
			keepUnusedDataFor: 5,
		}),
		getSuppliers: builder.query({
			query: () => ({
				url: `${PRODUCTS_URL}/supplier`,
			}),
		}),
		getBrandsFromProducts: builder.query({
			query: () => ({
				url: `${PRODUCTS_URL}/brand`,
			}),
		}),
		getProductDetails: builder.query({
			query: (productId) => ({
				url: `${PRODUCTS_URL}/${productId}`,
			}),
			providesTags: (result, error, productId) => [{ type: 'Product', id: productId }],
			keepUnusedDataFor: 5,
		}),
		getProductBatches: builder.query({
			query: (productId) => ({
				url: `${PRODUCTS_URL}/${productId}/batches`,
			}),
			providesTags: (result, error, productId) => [{ type: 'ProductBatch', id: productId }],
			keepUnusedDataFor: 5,
		}),
		createProductBatch: builder.mutation({
			query: ({ productId, ...body }) => ({
				url: `${PRODUCTS_URL}/${productId}/batches`,
				method: 'POST',
				body,
			}),
			invalidatesTags: (result, error, { productId }) => [{ type: 'ProductBatch', id: productId }],
		}),
		updateProductBatchQty: builder.mutation({
			query: ({ productId, batchId, qty }) => ({
				url: `${PRODUCTS_URL}/${productId}/batches/${batchId}`,
				method: 'PUT',
				body: { qty },
			}),
			invalidatesTags: (result, error, { productId }) => [{ type: 'ProductBatch', id: productId }],
		}),
		createProduct: builder.mutation({
			query: (data) => ({
				url: PRODUCTS_URL,
				method: 'POST',
				body: data,
			}),
			invalidatesTags: ['Product'],
		}),
		updateProduct: builder.mutation({
			query: (data) => ({
				url: `${PRODUCTS_URL}/${data._id}`,
				method: 'PUT',
				body: data,
			}),
			invalidatesTags: (result, error, data) => ['Product', { type: 'Product', id: data._id }],
		}),
		uploadProductImage: builder.mutation({
			query: (data) => ({
				url: `${UPLOAD_URL}`,
				method: 'POST',
				body: data,
			}),
			// 仅上传文件，未写入产品；勿 invalidate，否则编辑弹窗会被旧 product 冲掉刚选的多图
		}),
		deleteProduct: builder.mutation({
			query: (productId) => ({
				url: `${PRODUCTS_URL}/${productId}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['Product'],
		}),
		createReview: builder.mutation({
			query: (data) => ({
				url: `${PRODUCTS_URL}/${data.productId}/reviews`,
				method: 'POST',
				body: data,
			}),
			invalidatesTags: ['Product'],
		}),
		getTopProducts: builder.query({
			query: () => ({
				url: `${PRODUCTS_URL}/top`,
			}),
			providesTags: ['Product'],
			keepUnusedDataFor: 5,
		}),
		getProductOptions: builder.query({
			query: () => ({
				url: `${PRODUCTS_URL}/options`,
			}),
			providesTags: ['Product'],
			keepUnusedDataFor: 5,
		}),
		importProduct: builder.mutation({
			query: (data) => ({
				url: `${PRODUCTS_URL}/batch`,
				method: 'POST',
				body: data,
			}),
			invalidatesTags: ['Product'],
			keepUnusedDataFor: 5,
		}),
	}),
});

export const {
	useGetProductsQuery,
	useGetSuppliersQuery,
	useGetBrandsFromProductsQuery,
	useGetProductDetailsQuery,
	useGetProductBatchesQuery,
	useCreateProductBatchMutation,
	useUpdateProductBatchQtyMutation,
	useCreateProductMutation,
	useUpdateProductMutation,
	useUploadProductImageMutation,
	useDeleteProductMutation,
	useCreateReviewMutation,
	useGetTopProductsQuery,
	useImportProductMutation,
	useGetProductOptionsQuery,
} = productsApiSlice;
